import { ButtonDanger, ButtonLight } from 'front-end/src/components'
import React, { FC } from 'react'

import { t, Trans } from '@lingui/macro'

import { Modal } from '../../../components/common/modal/Modal'
import { notification } from '../../../components/common/notifications/Notifications'
import { useArchiveUserEnrolmentMutation } from './PathwayArchiveUserEnrolment.codegen'

interface IProps {
  pathwayEnrolmentId: number
  onCanceled: () => void
  onDeleted: () => void
}

export const PathwayArchiveUserEnrolment: FC<IProps> = (props: IProps) => {
  const [archiveUserEnrolmentMutation, { loading: isDeleting }] =
    useArchiveUserEnrolmentMutation()

  const handleOnDelete = async (): Promise<void> => {
    try {
      await archiveUserEnrolmentMutation({
        variables: {
          pathwayEnrolmentId: props.pathwayEnrolmentId
        }
      })
      notification.info(t`Pathway enrolment has been deleted`)

      props.onDeleted()
    } catch (e) {
      notification.error(t`Error deleting pathway enrolment`)
    }
  }

  const renderControls = () => {
    const { onCanceled } = props

    return (
      <>
        <ButtonLight onClick={onCanceled}>
          <Trans>Cancel</Trans>
        </ButtonLight>
        <ButtonDanger
          isLoading={isDeleting}
          onClick={handleOnDelete}
          dataTest="ArchiveEnrolmentModalButton"
        >
          <Trans>Delete this enrolment</Trans>
        </ButtonDanger>
      </>
    )
  }

  return (
    <Modal
      header={t`Delete pathway enrolment`}
      show
      controls={renderControls()}
      onHide={props.onCanceled}
    >
      <p>
        <Trans>
          Are you sure you want to delete this pathway enrolment? This action
          cannot be undone.
        </Trans>
      </p>
    </Modal>
  )
}
